// extracted by mini-css-extract-plugin
export default {"separator":"QSRab","column":"Du9bu","remove":"Bs91g","whitespacePlaceholder":"ndVuI"};